import { ReactNode } from "react";
import styles from "./Code.module.css";

interface InlineProps {
  children: ReactNode;
  variant?: "inline";
  className?: string;
}
interface BlockProps {
  children: string;
  variant: "block";
  /** Language hint. Not rendered (no syntax highlighting in v1). */
  language?: string;
  className?: string;
}
type Props = InlineProps | BlockProps;

export function Code(props: Props) {
  if (props.variant === "block") {
    const { children, language, className } = props;
    return (
      <pre
        className={`${styles.block}${className ? ` ${className}` : ""}`}
        data-language={language}
      >
        <code>{children}</code>
      </pre>
    );
  }
  const { children, className } = props;
  return (
    <code className={`${styles.inline}${className ? ` ${className}` : ""}`}>
      {children}
    </code>
  );
}
